// extracted by mini-css-extract-plugin
module.exports = {"reportModal":"ReportModal_reportModal__LcgYl","reportModalBody":"ReportModal_reportModalBody__vYCvJ","title":"ReportModal_title__D3amD"};